import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { PatientSupportForm } from "./PatientSupportForm";

/** "Contact us" for patients: the same support form as the invite-code flow, in a dialog. */
export function PatientContactDialog({ children }: { children: React.ReactNode }) {
    const [open, setOpen] = useState(false);

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>{children}</DialogTrigger>
            <DialogContent className="max-h-[90dvh] max-w-[calc(100%-1.5rem)] gap-5 overflow-y-auto rounded-3xl border border-purple-200/70 bg-white p-6 sm:max-w-lg sm:p-8 dark:border-purple-500/20 dark:bg-zinc-900">
                <DialogHeader className="text-left">
                    <p className="text-sm font-medium uppercase tracking-widest text-purple-500">Support</p>
                    <DialogTitle className="text-2xl font-light text-slate-900 dark:text-white">Contact us</DialogTitle>
                    <DialogDescription>Fill out the form and our team will get back to you shortly.</DialogDescription>
                </DialogHeader>
                <PatientSupportForm
                    idPrefix="contact"
                    successActionLabel="Close"
                    onSuccessAction={() => setOpen(false)}
                />
            </DialogContent>
        </Dialog>
    );
}
